import './VisitFilter.scss'
import { MultiSelectDropdown, SecondaryButton, useSessionStorage } from 'ui_kit_qmd'
import { memo, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import useOutsideClick from 'ui_kit_qmd/src/hooks/UseOutsideClick'
import { VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY } from '../../../../utils/constants'
import { filterRowTypeAPI, routeParam } from '../../constants'
import { useChangeSearchParams } from '../../../../utils/useChangeSearchParams'
import { getFilterRowAPI, getVisitSearchParams } from '../../VisitTools'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generateMultiSelectOptionsList = (serviceTypes, selectedVisitTypesListFromSearchParams) => {
  if (!serviceTypes.length) {
    return []
  }
  return (
    serviceTypes
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      .map((serviceType) =>
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        serviceType.VisitTypes.map((visitType) => ({
          value: `${serviceType.Name?.trim()} (${visitType.Name?.trim()})`,
          visitTypeId: visitType.VisitTypeId,
          isActive: selectedVisitTypesListFromSearchParams?.includes(visitType.VisitTypeId),
        })),
      )
      .flat()
  )
}
// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const VisitFilter = memo(({ onCloseFilterSettings, setFilterRow, loading }) => {
  const ref = useOutsideClick(onCloseFilterSettings)
  const { onChangeSearchParam } = useChangeSearchParams()

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const { initialVisitTypes } = getVisitSearchParams()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const serviceTypes = useSelector((state) => state.management.serviceTypes)

  const [selectVisitTypeDropdownOptions, setSelectVisitTypeDropdownOptions] = useState([])
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [storedSelectedList, setStoredSelectedList, removeStoredSelectedList] = useSessionStorage(
    VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY,
    [],
  )

  useEffect(() => {
    setSelectVisitTypeDropdownOptions(generateMultiSelectOptionsList(serviceTypes, initialVisitTypes))

    window.addEventListener('popstate', onCloseFilterSettings)

    return () => {
      window.removeEventListener('popstate', onCloseFilterSettings)
    }
  }, [])

  const onSetVisitTypeDropdownOptions = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newOptions) => {
      setSelectVisitTypeDropdownOptions(newOptions)
      setStoredSelectedList(newOptions)

      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const selectedVisitTypeIdList = newOptions.filter((t) => t.isActive).map((item) => item.visitTypeId)
      const apiRequestRow = getFilterRowAPI(filterRowTypeAPI.VISIT_TYPES_IDS, selectedVisitTypeIdList)
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      const isNeedToSetSearchParam = newOptions.some(({ isActive }) => isActive)

      setFilterRow(apiRequestRow)

      if (isNeedToSetSearchParam) {
        const selectedVisitTypesIdsList = newOptions
          // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
          .map(({ visitTypeId, isActive }) => (isActive ? visitTypeId : null))
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          .filter((id) => id)
        onChangeSearchParam({
          key: routeParam.VISIT_TYPES,
          value: JSON.stringify(selectedVisitTypesIdsList),
        })
      } else {
        onChangeSearchParam({ key: routeParam.VISIT_TYPES })
      }
    },
    [setFilterRow, setStoredSelectedList],
  )

  const onClearFilter = useCallback(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setSelectVisitTypeDropdownOptions((prev) => prev.map((t) => ({ ...t, isActive: false })))
    setFilterRow('')
    onChangeSearchParam({ key: routeParam.VISIT_TYPES })
    removeStoredSelectedList()
  }, [removeStoredSelectedList, setFilterRow])

  return (
    <div className='visits-page-visit-column-filter-container' ref={ref}>
      <MultiSelectDropdown
        isWithOptionsSort
        isDisabled={loading}
        isFlexible
        isEmptyMessage
        options={selectVisitTypeDropdownOptions}
        setOptions={onSetVisitTypeDropdownOptions}
        className='visits-page-table-filter-dropdown-select-visit-type'
        dropId='visits-page-table-filter-dropdown-select-visit-type-id'
        label='Service type (Visit type)'
      />
      <SecondaryButton
        btnText='Clear'
        imageAlt='AddAvailability'
        onPress={onClearFilter}
        id='clear-visit-type-options-btn'
        className='clear-visit-type-options-btn-container'
      />
    </div>
  )
})

export default VisitFilter
